/* eslint-disable */
import moment from 'moment';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import analyticsAction from '../../../../Actions/analytics.actions';
import { DefectImageResult } from '../../../../Components/Analytics/Defect';
import ImagesFinder from '../../../../Components/ImagesFinder/ImagesFinder';
import { DefectImageModal } from '../../../../Components/Modals';
import defectAnalyticsServices from '../../../../Services/Analytics Services/defect-analytics.services';
import { liveQCServices } from '../../../../Services/LiveQC';
import styles from './DefectImagesPage.module.scss';
import { Button } from '@mui/material';
import { Filter } from 'lucide-react';
import drawerActions from '@/Actions/drawer.actions';
import { filtersInfoChip } from '@/Helpers';
import { SelectPicker } from 'rsuite';

// const source =
// 'https://www.thespruceeats.com/thmb/vJUFf6L4p8y9Cn_1pE9Z7Ua9uok=/3000x2001/filters:fill(auto,1)/indian-style-burger-1957599-hero-01-266103a4bb4e4ee7b5feb4da2d2e99da.jpg';


const DefectImagesPage = (props) => {
	const [filters, setFilters] = useState({
		store: null,
		brand: null,
		processType: null,
		featureType: 'QUALITY',
		defects: [],
		products: [],
		vendors: [],
		productCategories: [],
		identification: 'Both',
		submissions: 0,
		timeType: '',
		dateRange: {
			active: false,
			from: new Date(),
			to: new Date(),
		},
	});
	const [pageLimit, setPageLimit] = useState(6);
	const { allDefectResults, fetchDefectImages, updateDefectImagesList, resetDefectImages, toggleFiltersDrawer } =
		props;

	useEffect(() => {
		resetDefectImages();
	}, []);

	const submitFindRequest = ({
		store = null,
		processTypes = null,
		brand,
		featureType,
		defects = [],
		products = [],
		productCategories = [],
		identification,
		timeType,
		vendors = [],
		dateRange = {},
		skuType,
	}) => {
		setFilters({
			store,
			processTypes,
			brand,
			featureType,
			defects,
			products,
			vendors,
			productCategories,
			identification,
			submissions: filters.submissions + 1,
			timeType,
			dateRange,
			skuType,
		});
		fetchDefectImages({
			entity: 'DEFECT_ANALYSIS',
			method: 'FIND_DEFECT_IMAGES',
			req: {
				params: {
					limit: pageLimit,
				},
				data: {
					storeId: store?.id,
					brandId: brand?.id,
					labels: defects,
					products: products?.id,
					processTypes: processTypes?.id,
					vendors: vendors?.id,
					productCategories: productCategories?.id,
					identification,
					type: featureType,
					skuType: skuType?.toUpperCase(),
					dateRangeFilter: dateRange?.active
						? {
							timeType : timeType?.value,
							from: moment(dateRange?.from).format(
								'YYYY-MM-DD'
							),
							to: moment(dateRange?.to).format('YYYY-MM-DD'),
						}
						: {},
				},
			},
		});
	};

	const fetchQCData = async (qcId) => {
		try {
			const req = {
				params: {
					qcId,
				},
			};

			const { data = null } = await liveQCServices.getPastData(req);

			return data;
		} catch {
			return null;
		}
	};

	const fetchDefectImagesById = async ({ page, defectId, identification }, index) => {
		const response = await defectAnalyticsServices.findDefectImagesById({
			params: {
				page,
				limit: pageLimit,
			},
			data: {
				labelId: defectId,
				storeId: filters.store?.id,
				products: filters.products?.id,
				processTypes: filters.processTypes?.id,
				brandId: filters.brand?.id,
				vendors: filters.vendors?.id,
				productCategories: filters.productCategories?.id,
				identification,
				type: filters?.featureType,
				dateRangeFilter: filters?.dateRange?.active
					? {
						timeType: filters?.timeType?.value,
						from: moment(filters?.dateRange.from).format('YYYY-MM-DD'),
						to: moment(filters?.dateRange.to).format('YYYY-MM-DD'),
					}
					: {},
			},
		});

		const { data = [] } = response;
		updateDefectImagesList(index, data);
		return data;
	};

	const filtersInfo = {
		header: {
			store: false,
			date: false,
			statusAndTypes: false,
			product: false,
			process: false,
		},
		store: {
			text: 'Store',
			show: true,
		},
		dateRange: {
			show: true,
			text: 'Date Range',
		},
		processType: {
			text: 'Process',
			show: true,
		},
		brand: {
			text: 'Brand',
			show: true,
		},
		features: {
			text: 'Features',
			show: true,
		},
		vendor: {
			text: 'Vendor',
			show: true,
		},
		skuType: {
			text: 'SKU Type',
			show: true,
		},
		product: {
			text: 'Product',
			show: true,
		},
		productCategory: {
			text: 'Product Category',
			show: true,
		},
		identificationType: {
			text: 'Identification Type',
			show: true,
		},
		timeType: {
			text: 'Date Time Type',
			show: true,
		},
		featureType: {
			text: 'Feature Type',
			show: true,
		},
	};

	const exportInfo = {
		hideExportAccordian : true,
	};

	return (
		<div className={styles.root}>
			<DefectImageModal />
			<ImagesFinder
				onSubmit={submitFindRequest}
				filtersInfo={filtersInfo}
				exportInfo={exportInfo}
			/>

			<div className='flex justify-between p-2 items-center'>
				<span className='font-bold text-[16px]'>Feature Images</span>
				<Button
					onClick={() => {
						toggleFiltersDrawer(true);
					}}
					className='flex items-center gap-2 px-4 py-2 text-white bg-teal-600 border border-gray-300 rounded-md hover:bg-teal-700'
				>
					Filter
					<Filter className='size-4' />
				</Button>
			</div>
			{filtersInfoChip(filtersInfo, filters)}
			<div className='flex items-center gap-2'>
				<span>
					Page Limit : 
				</span>
				<SelectPicker
					data={[6, 25, 50, 100].map((item) => ({
						label: item,
						value: item,
					}))}
					value={pageLimit}
					onChange={(value) => setPageLimit(value)}
					searchable={false}
					className='w-[200px]'
				/>
			</div>
			<div className={styles['image-results']}>
				{allDefectResults.map((defect, index) => {
					return (
						<DefectImageResult
							key={`${defect.id}${filters.submissions}`}
							identification={filters?.identification}
							fetchQCData={fetchQCData}
							fetchDefectImagesById={(req) => {
								return fetchDefectImagesById(req, index);
							}}
							defect={defect}
						/>
					);
				})}
				{allDefectResults.length === 0 && (
					<p className={styles.fallback}>No items to display</p>
				)}
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	const { FIND_DEFECT_IMAGES: allDefectResults } = state.analytics.DEFECT_ANALYSIS;
	const { DATE_RANGE_FILTER: dateRangeFilter } = state.analytics;
	return {
		allDefectResults,
		dateRangeFilter,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		fetchDefectImages: (...args) => {
			dispatch(analyticsAction.gateway(...args));
		},
		updateDefectImagesList: (...args) => {
			dispatch(analyticsAction.updateDefectImagesList(...args));
		},
		resetDefectImages: () => {
			dispatch(analyticsAction.resetDefectImages());
		},
		toggleFiltersDrawer: (...args) => {
			dispatch(drawerActions.toggleFiltersDrawer(...args));
		},
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(DefectImagesPage);
